import { COMPETITION_FEE_FIELDS as fields, competitionFeeCurrency } from "./competitionFeeFields"
import React, { useState } from "react"

// The category's fee templates the editor read offers, and whether a template's rows (templateFees) set every amount: the competition
// editor and "Set fees for all competitions" share both.
export const feeTemplates = choices => (choices.fees || []).flatMap(group => group.templates || [])
export const templateComplete = rows => rows.every(row => fields.every(([key]) => row[key] !== ""))

export const templateFees = (choices, selected, gameType, drawModel) => {
  const template = feeTemplates(choices).find(item => item.key === selected)
  const values = template?.fees?.[gameType]?.[drawModel]
  return choices.eligibleCountries.map(country => Object.fromEntries(fields.map(([key]) => {
    const value = values?.[key]?.[competitionFeeCurrency(country, key)]
    return [key, typeof value === "number" && Number.isFinite(value) && value >= 0
      && Math.abs(value * 100 - Math.round(value * 100)) < 0.000001 ? value : ""]
  })))
}

// A template replaces the amounts only from its preview of every country and an explicit Apply (ADR 0006, ticket 25): choosing it,
// or changing the game type or format afterwards, changes no amount.
export default function CompetitionFeeTemplate({ form, choices, selected, onSelect, onApply }) {
  const [preview, setPreview] = useState(null)
  const templates = feeTemplates(choices)
  const combination = [selected, form.values.gameType, form.values.drawModel].join(":")
  const replacements = templateFees(choices, selected, form.values.gameType, form.values.drawModel)
  const incomplete = !templateComplete(replacements)
  const identity = Boolean(form.values.gameType && form.values.drawModel)
  return <div className="mb-4">
    <label htmlFor="competition-fee-template">Fee template</label>
    <div className="d-flex flex-wrap align-items-center">
      <select id="competition-fee-template" className="form-control mb-2" value={selected} disabled={!identity} onChange={event => { onSelect(event.target.value); setPreview(null) }} aria-describedby="competition-fee-template-help">
        <option value="">Manual fees — no template</option>
        {templates.map(template => <option key={template.key} value={template.key}>{template.name || template.label || template.key}</option>)}
      </select>
      <button type="button" className="btn btn-outline-primary" disabled={!selected || !identity} onClick={() => setPreview(combination)}>Preview template</button>
    </div>
    <p id="competition-fee-template-help" className="text-muted mt-2">Preview a template's amounts for every country; only Apply template replaces the amounts entered so far.
      Collection models and Sportya portions remain as entered. Changing game type or format never changes the fees.
      {!identity && " Choose game type and format to select a template."}</p>
    {preview === combination && <section aria-label="Template preview" className="alert alert-info mt-3">
      <h6>Template preview</h6><p>The amounts this template sets for this game type and format. Applying them replaces the amounts entered so far.</p>
      {incomplete && <p className="text-danger">This template is incomplete: the amounts it does not configure stay to be completed manually.</p>}
      {choices.eligibleCountries.map((country, index) => <div className="mb-2" key={country.key}><strong>{country.name}</strong>
        <ul>{fields.map(([key, title]) => <li key={key}>{title}: {replacements[index][key] === "" ? "Not configured" : replacements[index][key] + " " + competitionFeeCurrency(country, key)}</li>)}</ul>
      </div>)}
      <button type="button" className="btn btn-primary" onClick={() => { onApply(replacements); setPreview(null) }}>Apply template</button>
      <button type="button" className="btn btn-light ml-2" onClick={() => setPreview(null)}>Close preview</button>
    </section>}
  </div>
}
